const WeatherMapUpdatingStatus = ({ message }) => (
  <span className="visually-hidden" role="status">
    {message}
  </span>
);

export default WeatherMapUpdatingStatus;
